export default {
  signIn: 'login/',
  projects: 'project/',
  getCharts: '/chart',
  getUserDetails: '/user',
  data: '/data',
  deleteProject: '/chart',
  notifications: '/message',
  svgUpload: 'charts/images/upload/',
  subscription: 'subscription/',
  microClaimRedeem: 'micro/claim/redeem'
};
